import { SEARCH_BANG_OPTIONS } from "@/constants/searchBang.constant";
export const getBang = (searchQuery) => {
    return searchQuery.trim().split(/\s+/)[0] ?? "";
};
export const getBangData = (bang) => SEARCH_BANG_OPTIONS.find((options) => options.bang === bang);
export const getGreeting = (name = "Mahes") => {
    const hour = new Date().getHours();
    // Time-based greeting
    const { greeting, emoji } = (() => {
        switch (true) {
            case hour >= 5 && hour < 12:
                return { greeting: "Mornin’", emoji: "☀️" };
            case hour >= 12 && hour < 17:
                return { greeting: "Hey there", emoji: "😎" };
            case hour >= 17 && hour < 21:
                return { greeting: "Eve’", emoji: "😉" };
            default:
                return { greeting: "Night", emoji: "🌜" };
        }
    })();
    // Search prompts
    const prompts = `searching?`;
    return `${greeting} ${name} ${emoji}, ${prompts}`;
};
